import runStrategies from 'Utils/run-strategies';
import strategies from './social-graph-description/index';
import sanitizeForReact from 'Utils/sanitize-for-react';

export default (options = {}, getState, extraThunkArgs) =>
  sanitizeForReact(
    runStrategies(strategies)(options, getState, extraThunkArgs),
  );
